import { Main } from 'components/Main';
import Page from 'components/Page';
import * as React from 'react';
import { Spinner } from 'components/Spinner';
const ViewConversationListRaw = React.lazy(() => import(/* webpackChunkName: "ViewConversationList" */ 'containers/Admin/ViewConversationList/ViewConversationList'));
export const ViewConversationList = () => (React.createElement(Page, { title: "View Conversation List", description: "View Conversation List" },
    React.createElement(Main, { sidebar: true },
        React.createElement(React.Suspense, { fallback: React.createElement(Spinner, { full: true }) },
            React.createElement(ViewConversationListRaw, null)))));
